module.exports = __webpack_public_path__ + "img/B20-20190415_01.5261e081.jpg";